import { useState, useEffect, useRef } from "react";
import { Container, Col, Modal, Form } from "react-bootstrap";
import { RiDeleteBinLine } from "react-icons/ri";
import { FiEye } from "react-icons/fi";
import { Calendar } from "primereact/calendar";
import { useMsal } from "@azure/msal-react";
import { Dropdown } from "primereact/dropdown";
import { Tooltip } from "primereact/tooltip";
// import { Toast } from "primereact/toast";
import { toast } from "react-toastify";

import "./primaryReview.css";
import { getRequest, postRequest } from "../../../actions/Handler";
import FileUpload from "../../fileUpload/fileUpload";
import RecommendationView from "../recommendationView/recommendationView";
import Table from "../../table/table";
import DeleteConfirmation from "../deleteConfirmation/deleteConfirmation";
import moment from "moment";

export default function PrimaryModal({
  showPopup,
  updatePrimaryModalState,
  popupName,
  reviewDetail,
  eventReportId,
  readOnly,
  primaryPopupReadOnly,
  onExit,
  eventTitle,
  setReloadCardVal
}: any) {
  const [state] = useState({
    userDetail: useMsal().accounts,
  });

  const [saveLoader, setSaveLoader] = useState(false);
  // const toast = useRef<Toast>(null);

  const [attachmentButtons, changeAttachmentButtons] = useState({
    upload: true,
    close: true,
  });

  const [analysisRequired, setAnalysisRequired] = useState(false);
  const [fileCategory, setFileCategory] = useState("");

  interface RecommendationRowProps {
    eventReportReviewRecommendationId: number;
    recommendationText: string;
    recommendationStartText: string;
  }

  const [recommendationRow, setRecommendationRow] = useState<
    RecommendationRowProps[]
  >([]);

  interface AttachmentRowProps {
    eventReportReviewAttachmentId: number;
    fileCategory: string;
    fileName: string;
    fileContent: string;
  }

  const [attachmentRow] = useState<AttachmentRowProps[]>([]);
  const [fileAttachments, setFileAttachments] = useState([]);

  const [inputValues, setInputValue] = useState({
    recordHash: "",
    eventReportKey: 0,
    reviewType: "",
    analysisType: "",
    hasRecommendation: false,
    reviewComment: "",
    reviewScoringKey: undefined,
    reportReviewAttachments: attachmentRow,
    reviewRecommendations: recommendationRow,
    reviewRecommendationsCompletedOn: undefined,
    reviewRecommendationsCompletedBy: "",
    reviewCompletedBy: "",
    reviewCompletedOn: undefined,
    sharedCommentaryText: "",
  });

  interface ScoringProps {
    id: number;
    name: String;
  }
  const [scoringOptions, setScoringOptions] = useState<ScoringProps[]>([]);
  const [recommendationOptions] = useState([
    {
      name: "Provider(s) to be advised/counseled (MD and CRNA):",
      id: "Provider(s) to be advised/counseled (MD and CRNA):",
    },
    {
      name: "Education Item for Department meeting:",
      id: "Education Item for Department meeting:",
    },
  ]);
  const [fileOptions] = useState([
    {
      name: "Analysis",
      id: "Analysis",
    },
    {
      name: "Other",
      id: "Other",
    },
  ]);

  const [errorValues, setErrorValue] = useState({
    isFullReview: "",
    analysis: "",
    scoring: "",
    reviewCompleted: "",
    recommendations: "",
    attachment: "",
  });

  const [recommendationDetail, setRecommendationDetail] = useState({
    recommendationStartText: "",
    recommendationText: "",
  });
  const [recommendationError, setRecommendationError] = useState({
    recommendationStartText: "",
    recommendationText: "",
  });
  const [viewRecommendationDetail, setViewRecommendationDetail] = useState({
    recommendationStartText: "",
    recommendationText: "",
    showRecommendationPopup: false,
  });

  const [deletePopup, setDeletePopup] = useState({
    showPopup: false,
    popupMessage: "",
    popupType: "",
    data: null,
    confirm: false,
  });

  useEffect(() => {
    setSaveLoader(true);
    async function setDetails() {
      if (readOnly) {
        reviewDetail.reviewCompletedOn = new Date(
          reviewDetail.reviewCompletedOn
        );
        reviewDetail.recommendationCompletedBy =
          reviewDetail.reviewRecommendationsCompletedByUserName;
        reviewDetail.reviewRecommendationsCompletedOn =
          reviewDetail.reviewRecommendationsCompletedOn;
        reviewDetail.reviewCompletedBy = reviewDetail.reviewCompletedByUserName;
        reviewDetail.recommendationCompletedOn =
          reviewDetail.reviewRecommendationsCompletedOn
            ? formatDate(reviewDetail.reviewRecommendationsCompletedOn)
            : null;
        reviewDetail.sharedCommentaryText=reviewDetail.sharedCommentary?.comment
        var fileAttachmentsData = (await Promise.all(
          reviewDetail.reportReviewAttachments.map(
            async (element: any, index: any) => {
              return {
                attachmentId: index,
                attachment: null,
                attachmentName: element.fileName,
                attachmentUrl: "",
                //element.encodingType + (await getFileUrl(element.blobId)),
                attachmentSize: "0",
                modifiedBy: element.createdBy,
                modifiedDate: formatDate(element.createdOn),
                analysis: element.fileCategory,
                attachmentInfo: element.attachmentInfo,
                blobId: element.blobId,
                encodingType: element.encodingType,
                type: 1,
              };
            }
          )
        )) as any;
        setFileAttachments(fileAttachmentsData);
        setInputValue(reviewDetail);
        setRecommendationRow(reviewDetail.reviewRecommendations);
      } else {
        var inputData = { ...inputValues };
        inputData["reviewType"] = popupName;
        inputData["eventReportKey"] = +eventReportId;
        setInputValue(inputData);
      }
    }
    setDetails();
    setSaveLoader(false);
  }, [showPopup, readOnly, reviewDetail]);
  const getFileUrl = (blobId: any) => {
    return new Promise((resolve) => {
      getRequest({
        url: `api/EventReport/DownloadAttachment?eventReportId=${+eventReportId}&blobId=${blobId}`,
      })
        .then((res) => {
          return resolve(res);
        })
        .catch((e) => {
          console.log(e);
          return resolve("");
        });
    });
  };

  useEffect(() => {
    var type = popupName === "Primary Review" ? 1 : 2;
    getRequest({
      url:
        "api/EventReportReview/GetReviewScoringByReviewType?reviewType=" + type,
    }).then((res) => {
      var scoringData = [];
      for (let i = 0; i < res.length; i++) {
        const element = res[i];
        scoringData.push({
          id: element.id,
          name: element.name,
        });
      }
      setScoringOptions(scoringData);
    });
  }, [popupName]);

  useEffect(() => {
    if (deletePopup.confirm) {
      switch (deletePopup.popupType) {
        case "recommendation":
          deleteRecommendation(deletePopup.data);
      }
    }
  }, [deletePopup]);

  const deletePopupChange = (data: any, type: any) => {
    setDeletePopup({
      showPopup: true,
      popupMessage: "Are you sure you want to delete this item?",
      popupType: type,
      data: data,
      confirm: false,
    });
  };

  const cancelDelete = () => {
    setDeletePopup({
      showPopup: false,
      popupMessage: "",
      popupType: "",
      data: null,
      confirm: false,
    });
  };
  const confirmDelete = () => {
    var deleteData = { ...deletePopup };
    deleteData["confirm"] = true;
    deleteData["showPopup"] = false;
    setDeletePopup(deleteData);
  };

  const preventDefault = (e: any) => {
    e.preventDefault();
  };

  const formatDate = (dos: any) => {
    const date = new Date(dos);
    const yyyy = date.getFullYear();
    let mm = (date.getMonth() + 1).toString(); // Months start at 0!
    let dd = date.getDate().toString();

    if (+dd < 10) dd = "0" + dd;
    if (+mm < 10) mm = "0" + mm;

    return mm + "/" + dd + "/" + yyyy;
  };

  const handleFormChange = (event: any) => {
    let formParams = { ...inputValues } as any;
    let formValue;
    if (event.target.name === "analysisType") {
      if (formParams[event.target.name] === event.target.value) {
        event.target.value = null;
      }
      formValue = event.target.value;
      setAnalysisRequired(formValue === "Full Review" ? true : false);
    } else if (event.target.name === "hasRecommendation") {
      formValue = !event.target.checked;
    }
    else {
      formValue = event.target.value;
    }
    formParams[event.target.name] = formValue;
    setInputValue(formParams);

    //ERROR VALIDATION
    let errorVal = { ...errorValues };
    if (event.target.name === "reviewComment") {
      if (formParams.analysisType != "") {
        if (formParams.analysisType == "Full Review") {
          errorVal["analysis"] = "Analysis is required";
        } else {
          errorVal["analysis"] = "";
        }
      }
      if (formParams.reviewComment.length > 4000) {
        errorVal["analysis"] = "Must enter less than 4000 characters!";
      } else {
        errorVal["analysis"] = "";
      }
    }
    if (event.target.name === "analysisType") {
      if (formParams.analysisType === "") {
        errorVal["isFullReview"] = "Depth of analysis is required";
      } else {
        errorVal["isFullReview"] = "";
        if (
          formParams.analysisType == "Full Review" &&
          formParams.reviewComment.trim() === ""
        ) {
          errorVal["analysis"] = "Analysis is required";
        } else {
          errorVal["analysis"] = "";
        }
      }
    }
    if (event.target.name === "reviewScoringKey") {
      if (formParams.reviewScoringKey === undefined) {
        errorVal["scoring"] = "Scoring is required";
      } else {
        errorVal["scoring"] = "";
      }
    }
    if (event.target.name === "reviewCompletedOn") {
      if (formParams.reviewCompletedOn === undefined) {
        errorVal["reviewCompleted"] = "Review Completed Date is required";
      } else {
        errorVal["reviewCompleted"] = "";
      }
    }
    if (event.target.name === "hasRecommendation") {
      if (
        formParams.hasRecommendation &&
        formParams.reviewRecommendations.length <= 0
      ) {
        errorVal["recommendations"] = "Recommendation is required";
      } else {
        errorVal["recommendations"] = "";
      }
    }
    setErrorValue(errorVal);
  };

  const handleRecommendationChange = (event: any) => {
    let formParams = { ...recommendationDetail } as any;
    let formValue;
    var errVal = { ...recommendationError };

    formValue = event.target.value;
    formParams[event.target.name] = formValue;
    if (event.target.name === "recommendationStartText") {
      formParams["recommendationText"] = formValue;
      errVal["recommendationText"] = "";
      // if (formParams["recommendationStartText"] === "") {
      //   errVal["recommendationStartText"] = "Recommendation Type is required";
      // } else {
      //   errVal["recommendationStartText"] = "";
      // }
    } else {
      if (formParams["recommendationText"] === "") {
        errVal["recommendationText"] = "Recommendation Description is required";
      } else {
        if (formParams["recommendationText"].length > 4000) {
          errVal["recommendationText"] =
            "Must enter less than 4000 characters!";
        } else {
          errVal["recommendationText"] = "";
        }
      }
    }
    setRecommendationDetail(formParams);
    setRecommendationError(errVal);
  };

  const onSubmitRecommendation = (event: any) => {
    event.preventDefault();
    var allow = true;
    var errVal = { ...recommendationError };
    // if (recommendationDetail["recommendationStartText"] === "") {
    //   allow = false;
    //   errVal["recommendationStartText"] = "Recommendation Type is required";
    // } else {
    //   errVal["recommendationStartText"] = "";
    // }
    if (recommendationDetail["recommendationText"] === "") {
      allow = false;
      errVal["recommendationText"] = "Recommendation Description is required";
    } else {
      if (recommendationDetail["recommendationText"].length > 4000) {
        allow = false;
        errVal["recommendationText"] = "Must enter less than 4000 characters!";
      } else {
        errVal["recommendationText"] = "";
      }
    }
    if (!allow) {
      setRecommendationError(errVal);
      return false;
    }
    const date = new Date();
    const yyyy = date.getFullYear();
    let mm = (date.getMonth() + 1).toString(); // Months start at 0!
    let dd = date.getDate().toString();

    if (+dd < 10) dd = "0" + dd;
    if (+mm < 10) mm = "0" + mm;

    const today = mm + "/" + dd + "/" + yyyy;

    var id =
      recommendationRow.length > 0
        ? recommendationRow[recommendationRow.length - 1]
          .eventReportReviewRecommendationId + 1
        : 1;

    setRecommendationRow([
      ...recommendationRow,
      {
        eventReportReviewRecommendationId: id,
        recommendationStartText: recommendationDetail.recommendationStartText,
        recommendationText: recommendationDetail.recommendationText,
      },
    ]);
    var inputVal = { ...inputValues };
    inputVal.reviewRecommendations = [
      ...recommendationRow,
      {
        eventReportReviewRecommendationId: id,
        recommendationStartText: recommendationDetail.recommendationStartText,
        recommendationText: recommendationDetail.recommendationText,
      },
    ];
    setInputValue(inputVal);

    var errorVal = { ...errorValues };
    if (
      inputVal.hasRecommendation &&
      inputVal.reviewRecommendations.length <= 0
    ) {
      errorVal["recommendations"] = "Recommendation is required";
    } else {
      errorVal["recommendations"] = "";
    }
    setErrorValue(errorVal);

    setRecommendationDetail({
      recommendationStartText: "",
      recommendationText: "",
    });
  };

  const deleteRecommendation = (rowData: any) => {
    var arr = [...recommendationRow] as any;
    const requiredIndex = arr.findIndex((el: any) => {
      return (
        el.eventReportReviewRecommendationId ===
        rowData.eventReportReviewRecommendationId
      );
    });
    if (requiredIndex === -1) {
      return false;
    }
    arr.splice(requiredIndex, 1);
    setRecommendationRow(arr);

    var inputVal = { ...inputValues };
    inputVal.reviewRecommendations = arr;
    setInputValue(inputVal);

    var errorVal = { ...errorValues };
    if (inputVal.hasRecommendation && arr.length <= 0) {
      errorVal["recommendations"] = "Recommendation is required";
    } else {
      errorVal["recommendations"] = "";
    }
    setErrorValue(errorVal);
  };

  const showRecommendationPopup = (rowData: any) => {
    setViewRecommendationDetail({
      recommendationStartText: rowData.recommendationStartText,
      recommendationText: rowData.recommendationText,
      showRecommendationPopup: true,
    });
  };

  const hideRecommendationPopup = () => {
    setViewRecommendationDetail({
      recommendationStartText: "",
      recommendationText: "",
      showRecommendationPopup: false,
    });
  };

  const setFileUpload = (data: any, type = 1) => {
    var formVal = { ...inputValues } as any;
    var reportAttachment = data.map((element: any) => {
      return {
        // eventReportReviewAttachmentId: element.attachmentId,
        fileCategory: element.analysis,
        fileName: element.attachmentName,
        fileContent: element.attachment,
      };
    });
    formVal["reportReviewAttachments"] = reportAttachment;
    if (type === 1) {
      var errs = { ...errorValues };
      if (data.length <= 0) {
        errs.attachment = "File attachment is required";
      } else {
        errs.attachment = "";
      }
      setErrorValue(errs);
      setInputValue(formVal);
    } else {
      setInputValue({
        recordHash: "",
        eventReportKey: 0,
        reviewType: "",
        analysisType: "",
        hasRecommendation: false,
        reviewComment: "",
        reviewScoringKey: undefined,
        reportReviewAttachments: attachmentRow,
        reviewRecommendations: recommendationRow,
        reviewRecommendationsCompletedOn: undefined,
        reviewRecommendationsCompletedBy: "",
        reviewCompletedBy: "",
        reviewCompletedOn: undefined,
        sharedCommentaryText: "",
      });
    }
  };

  const mess = () => {
    // toast.current?.show({
    //   severity: "success",
    //   summary: "Success",
    //   detail: "Review completed successfully",
    // });
    toast("Review completed successfully", {
      type: "success",
      autoClose: 2000,
      pauseOnHover: true,
      delay: 0,
    });
  };
  const errormess = () => {
    // toast.current?.show({
    //   severity: "error",
    //   summary: "Error!",
    //   detail: "Something wrong happened!",
    // });
    toast("Something went wrong!", {
      type: "error",
      autoClose: 2000,
      pauseOnHover: true,
      delay: 0,
    });
  };
  const ErrorMessageFileType = () => {
    toast("Some of the attached file types are not valid!", {
      type: "error",
      autoClose: 2000,
      pauseOnHover: true,
      delay: 0,
    });
  };

  const GetMaxDate = () => {
    var dt = new Date();
    // dt.setTime(dt.getTime() + dt.getTimezoneOffset() * 60 * 1000);
    // var offset = -240; //Timezone offset for EST in minutes.
    // var estDate = new Date(dt.getTime() + offset * 60 * 1000);
    return dt;
  };

  const onSubmit = async () => {
    let errorVal = { ...errorValues };
    let formValid = true;
    if (inputValues.analysisType === "") {
      errorVal["isFullReview"] = "Depth of analysis is required";
      formValid = false;
    } else {
      errorVal["isFullReview"] = "";
      if (
        inputValues.reviewComment === "" &&
        inputValues.analysisType === "Full Review"
      ) {
        errorVal["analysis"] = "Analysis is required";
        formValid = false;
      } else {
        errorVal["analysis"] = "";
      }
    }
    if (inputValues.reviewComment.length > 4000) {
      errorVal["analysis"] = "Must enter less than 4000 characters!";
      formValid = false;
    } else if (
      inputValues.reviewComment === "" &&
      inputValues.analysisType === "Full Review"
    ) {
      errorVal["analysis"] = "Analysis is required";
      formValid = false;
    } else {
      errorVal["analysis"] = "";
    }
    if (inputValues.reviewScoringKey === undefined) {
      errorVal["scoring"] = "Scoring is required";
      formValid = false;
    } else {
      errorVal["scoring"] = "";
    }
    if (inputValues.reviewCompletedOn === undefined) {
      errorVal["reviewCompleted"] = "Review Completed Date is required";
      formValid = false;
    } else {
      errorVal["reviewCompleted"] = "";
    }
    if (
      inputValues.hasRecommendation &&
      inputValues.reviewRecommendations.length <= 0
    ) {
      errorVal["recommendations"] = "Recommendation is required";
      formValid = false;
    } else {
      errorVal["recommendations"] = "";
    }
    setErrorValue(errorVal);
    if (!formValid) return false;

    var utcDate = null;

    if (inputValues.reviewCompletedOn) {
      var eventDate = new Date(inputValues.reviewCompletedOn);
      var currentDateTime = new Date();
      eventDate.setTime(currentDateTime.getTime())
      utcDate = eventDate.toISOString();
    }
    var reqData = {
      eventReportKey: inputValues.eventReportKey,
      reviewType: inputValues.reviewType,
      analysisType: inputValues.analysisType,
      hasRecommendation: inputValues.hasRecommendation,
      reviewComment: inputValues.reviewComment,
      reviewScoringKey: inputValues.reviewScoringKey,
      reviewCompletedOn: utcDate,
      reviewRecommendations: inputValues.reviewRecommendations,
      reportReviewAttachments: inputValues.reportReviewAttachments,
      sharedCommentary: inputValues.sharedCommentaryText,
      siteName:reviewDetail?.siteName
    };

    // postRequest({ url: "api/EventReportReview/Submit", data: reqData })
    //   .then((res) => {
    //     mess();
    //     setTimeout(() => {
    //       resetForm();
    //       updatePrimaryModalState();
    //     }, 1000);
    //   })
    //   .catch((e) => {
    //     errormess();
    //     console.log(e);
    //   });

    if (formValid) {
      setSaveLoader(true);
    } else {
      setSaveLoader(false);
    }

    postRequest({ url: "api/EventReportReview/Submit", data: reqData })
      .then((res) => {
        mess();
        // setTimeout(() => {
        setSaveLoader(false);
        resetForm();
        setReloadCardVal();
        updatePrimaryModalState();
        // }, 1000);
        onExit();
      })
      .catch((e) => {
        e.status === 415 ? ErrorMessageFileType() : errormess();
        setSaveLoader(false);
      });
  };

  const resetForm = () => {
    setInputValue({
      recordHash: "",
      eventReportKey: 0,
      reviewType: "",
      analysisType: "",
      hasRecommendation: false,
      reviewComment: "",
      reviewScoringKey: undefined,
      reportReviewAttachments: attachmentRow,
      reviewRecommendations: recommendationRow,
      reviewRecommendationsCompletedOn: undefined,
      reviewRecommendationsCompletedBy: "",
      reviewCompletedBy: "",
      reviewCompletedOn: undefined,
      sharedCommentaryText: "",

    });
    setErrorValue({
      isFullReview: "",
      analysis: "",
      scoring: "",
      reviewCompleted: "",
      recommendations: "",
      attachment: "",
    });
    setAnalysisRequired(false);
    setRecommendationDetail({
      recommendationStartText: "",
      recommendationText: "",
    });
    setRecommendationError({
      recommendationStartText: "",
      recommendationText: "",
    });
    setRecommendationRow([]);
    setFileUpload([], 0);
    setFileCategory("");
  };
  const columns = [
    {
      header: "Actions",
      body: (rowData: any) => (
        <>
          <button
            className="buttonCss me-2 buttonIcon"
            disabled={readOnly}
            onClick={(event) => {
              preventDefault(event);
              deletePopupChange(rowData, "recommendation");
            }}
          >
            <RiDeleteBinLine
              className="chooseIcon"
              style={{ fontSize: "14px" }}
            />
          </button>
          <button
            className="buttonCss buttonIcon"
            onClick={(event) => {
              preventDefault(event);
              showRecommendationPopup(rowData);
            }}
          >
            <FiEye className="chooseIcon" style={{ fontSize: "14px" }} />
          </button>
        </>
      ),
      filter: false,
      width: "50%",
    },
    {
      header: "Recommendation",
      field: "recommendationStartText",
      body: (rowData: any) => (
        <>
          {rowData.recommendationText.length > 90
            ? rowData.recommendationText.slice(0, 89) + "..."
            : rowData.recommendationText}
        </>
      ),
      filter: false,
      width: "50%",
    },
  ];

  if (showPopup) {
    return (
      <>
        {saveLoader ? (
          <>
            <div id="q11">
              <div className="loading">
                <div className="obj"></div>
              </div>
            </div>{" "}
          </>
        ) : null}
        {/* <Toast ref={toast}></Toast> */}

        <Modal
          show={showPopup}
          onHide={() => {
            updatePrimaryModalState();
            resetForm();
            primaryPopupReadOnly(false);
          }}
          backdrop="static"
          size="lg"
          keyboard={false}
          enforceFocus={true}
          scrollable={true}
        >
          <Modal.Header closeButton>
            <Modal.Title
              style={{
                color: "#495057",
                fontSize: "15px",
                fontWeight: "600",
              }}
            >
              {popupName}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-0 ps-2 removehscroll">
            <form
              style={{ color: "#495057", fontSize: "12px", fontWeight: "600" }}
            >
              <Container fluid={true} className="p-0">
                <Col md="12" sm="12" xs="12" className="">
                  {eventTitle}
                </Col>
                <Col md="6" sm="12" xs="12" className="pb-0">
                  <label>
                    Depth of Analysis <span style={{ color: "red" }}> *</span>
                  </label>
                  <Form.Group className="mt-1">
                    <Form.Check
                      inline
                      type="radio"
                      label="&nbsp;&nbsp;Minimal Review"
                      name="analysisType"
                      onClick={handleFormChange}
                      onChange={(e) => { }}
                      checked={
                        inputValues.analysisType === "Minimal Review"
                          ? true
                          : false
                      }
                      value="Minimal Review"
                      disabled={readOnly}
                    />
                    <Form.Check
                      inline
                      type="radio"
                      label="&nbsp;&nbsp;Full Review"
                      name="analysisType"
                      onClick={handleFormChange}
                      onChange={(e) => { }}
                      checked={
                        inputValues.analysisType === "Full Review"
                          ? true
                          : false
                      }
                      value="Full Review"
                      disabled={readOnly}
                    />
                    <p className="err-text">{errorValues.isFullReview}</p>
                  </Form.Group>
                </Col>


                <Col md="12" sm="12" xs="12" className="pb-0 pt-0">
                  <label>
                    Analysis{" "}
                    <span
                      style={{
                        display: analysisRequired ? "contents" : "none",
                        color: "red",
                      }}
                    >
                      *
                    </span>
                  </label>
                  <Form.Group className="mb-3" controlId="formBasicCheckbox">
                    <Form.Control
                      as="textarea"
                      rows={6}
                      name="reviewComment"
                      value={inputValues.reviewComment}
                      onChange={handleFormChange}
                      disabled={readOnly}
                    />
                    <p className="err-text">{errorValues.analysis}</p>
                  </Form.Group>
                </Col>
                <Col md="12" sm="12" xs="12" className="pb-0 pt-0"></Col>
                {(() => {
                  if (popupName === "Primary Review") {
                    return (
                      <>
                        <Col md="6" sm="12" xs="12" className="pb-0 pt-0">
                          <Form.Group
                            className="mb-3 scoring"
                            controlId="formBasicCheckbox"
                          >
                            <label>
                              Scoring (0-4){" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <Dropdown
                              style={{ width: "100%" }}
                              value={inputValues.reviewScoringKey}
                              options={scoringOptions}
                              optionLabel="name"
                              optionValue="id"
                              name="reviewScoringKey"
                              onChange={handleFormChange}
                              disabled={readOnly}
                            />
                            <p className="err-text">{errorValues.scoring}</p>
                          </Form.Group>
                        </Col>
                      </>
                    );
                  } else {
                    return (
                      <>
                        <Col md="6" sm="12" xs="12" className="pb-0 pt-0">
                          <Form.Group
                            className="mb-3 scoring"
                            controlId="formBasicCheckbox"
                          >
                            <label>
                              Scoring (1-4){" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <Dropdown
                              style={{ width: "100%" }}
                              value={inputValues.reviewScoringKey}
                              options={scoringOptions}
                              optionLabel="name"
                              optionValue="id"
                              name="reviewScoringKey"
                              onChange={handleFormChange}
                              disabled={readOnly}
                            />
                            <p className="err-text">{errorValues.scoring}</p>
                          </Form.Group>
                        </Col>
                      </>
                    );
                  }
                })()}
                <Col md="12" sm="12" xs="12" className="pb-0 pt-0">
                  <div className="formLabel">
                    <label>Recommendations</label>
                  </div>
                  <div className="formContent mb-3">
                    <Form.Group>
                      <Form.Check
                        inline
                        type="checkbox"
                        label="&nbsp;&nbsp;No Further Actions Recommended"
                        name="hasRecommendation"
                        onClick={handleFormChange}
                        onChange={(e) => { }}
                        checked={!inputValues.hasRecommendation}
                        disabled={readOnly}
                      />
                      <p className="err-text">{errorValues.recommendations}</p>
                    </Form.Group>
                    {(() => {
                      if (inputValues.hasRecommendation && !readOnly) {
                        return (
                          <>
                            <Col md="3" sm="6" xs="12" className="pb-0">
                              <Form.Group controlId="formBasicCheckbox">
                                <label>New Recommendation Type</label>
                                <Dropdown
                                  style={{ width: "100%" }}
                                  value={
                                    recommendationDetail.recommendationStartText
                                  }
                                  options={recommendationOptions}
                                  optionLabel="name"
                                  optionValue="name"
                                  name="recommendationStartText"
                                  onChange={handleRecommendationChange}
                                />
                              </Form.Group>
                              <p className="err-text">
                                {recommendationError.recommendationStartText}
                              </p>
                            </Col>
                            <Col md="12" sm="12" xs="12" className="pt-0 pb-0">
                              <Form.Group
                                className="review-space"
                                controlId="formBasicCheckbox"
                              >
                                <label>New Recommendation</label>
                                <Form.Control
                                  as="textarea"
                                  rows={6}
                                  onChange={handleRecommendationChange}
                                  value={
                                    recommendationDetail.recommendationText
                                  }
                                  name="recommendationText"
                                />
                              </Form.Group>
                              <p className="err-text">
                                {recommendationError.recommendationText}
                              </p>
                            </Col>
                            <Col
                              md="12"
                              sm="12"
                              xs="12"
                              className="d-flex flex-row-reverse pb-0 pt-0"
                            >
                              <Form.Group
                                className="mb-3 mt-2"
                                controlId="formBasicCheckbox"
                              >
                                <button
                                  className="buttonCss"
                                  onClick={onSubmitRecommendation}
                                >
                                  Add Recommendation
                                </button>
                              </Form.Group>
                            </Col>
                            <Col md="12" sm="12" xs="12" className="pt-0">
                              <div className="mb-3">
                                <Table
                                  column={columns}
                                  rows={recommendationRow}
                                  lazy={false}
                                  screen="primaryReview"
                                  pagination={false}
                                ></Table>
                              </div>
                            </Col>
                          </>
                        );
                      } else if (inputValues.hasRecommendation && readOnly) {
                        return (
                          <>
                            <Col md="12" sm="12" xs="12">
                              <div className="mb-3">
                                <Table
                                  column={columns}
                                  rows={recommendationRow}
                                  lazy={false}
                                  screen="primaryReview"
                                  pagination={false}
                                ></Table>
                              </div>
                            </Col>
                          </>
                        );
                      } else {
                        return <></>;
                      }
                    })()}
                  </div>
                </Col>
                <Col md="12" sm="12" xs="12" className="pb-0 pt-0">
                  <div className="formLabel">
                    <label>File Attachments</label>
                  </div>
                  <div className="formContent1 mb-3">
                    <Form.Group controlId="formBasicCheckbox">
                      {(() => {
                        if (!readOnly) {
                          return (
                            <Col md="4" sm="6" xs="12" className="pb-0">
                              <label>File Attachment Category</label>
                              <Dropdown
                                style={{ width: "100%" }}
                                value={fileCategory}
                                options={fileOptions}
                                optionLabel="name"
                                optionValue="name"
                                name="fileCategory"
                                onChange={(e: any) =>
                                  setFileCategory(e.target.value)
                                }
                              />
                            </Col>
                          );
                        } else {
                          return <></>;
                        }
                      })()}
                      <FileUpload
                        buttonValidators={attachmentButtons}
                        buttonValidation={changeAttachmentButtons}
                        data={fileAttachments}
                        handler={setFileUpload}
                        fileCategory={fileCategory}
                        readOnly={readOnly}
                        eventReportId={eventReportId}
                      />
                    </Form.Group>
                  </div>
                </Col>
                <Col md="6" sm="6" xs="12" className="pb-0 pt-0 review">
                  <label>
                    Review Completed On <span style={{ color: "red" }}>*</span>
                  </label>
                  <Calendar
                    readOnlyInput
                    name="reviewCompletedOn"
                    value={inputValues.reviewCompletedOn}
                    onChange={(date: any) => {
                      let formParams = { ...inputValues } as any;
                      formParams["reviewCompletedOn"] = date.value;
                      setInputValue(formParams);
                      let errorVal = { ...errorValues };

                      if (formParams.reviewCompletedOn === null) {
                        errorVal["reviewCompleted"] =
                          "Review Completed Date is required";
                      } else {
                        errorVal["reviewCompleted"] = "";
                      }
                      setErrorValue(errorVal);
                    }}
                    className="calender-custom"
                    style={{
                      width: "100%",
                    }}
                    showIcon
                    viewDate={GetMaxDate()}
                    maxDate={GetMaxDate()}
                    disabled={readOnly}
                    dateFormat="mm/dd/yy"
                  />
                  <p className="err-text">{errorValues.reviewCompleted}</p>
                </Col>
                {(() => {
                  if (readOnly) {
                    return (
                      <Col md="12" sm="12" xs="12" className="removepadding">
                        <Container
                          fluid={true}
                          className="d-flex flex-row mt-2 p-0"
                        >
                          <Col xs="6" sm="3" md="3">
                            Review Completed By:
                          </Col>
                          <Col xs="9" sm="9" md="9" className="LightText">
                            {reviewDetail.reviewCompletedBy}
                          </Col>
                        </Container>
                        {(() => {
                          if (reviewDetail.recommendationCompletedOn) {
                            return (
                              <Container
                                fluid={true}
                                className="d-flex flex-row mt-2 p-0"
                              >
                                <Col xs="6" sm="3" md="3">
                                  Recommendations Completed:
                                </Col>
                                <Col xs="9" sm="9" md="9" className="LightText">
                                  {reviewDetail.recommendationCompletedOn
                                    ? reviewDetail.recommendationCompletedOn
                                    : "-"}
                                </Col>
                              </Container>
                            );
                          } else {
                            return <></>;
                          }
                        })()}
                        {(() => {
                          if (reviewDetail.recommendationCompletedBy) {
                            return (
                              <Container
                                fluid={true}
                                className="d-flex flex-row mt-2 p-0"
                              >
                                <Col xs="6" sm="3" md="3">
                                  Recommendations Completed By:
                                </Col>
                                <Col xs="9" sm="9" md="9" className="LightText">
                                  {reviewDetail.recommendationCompletedBy
                                    ? reviewDetail.recommendationCompletedBy
                                    : "-"}
                                </Col>
                              </Container>
                            );
                          } else {
                            return <></>;
                          }
                        })()}
                      </Col>
                    );
                  } else {
                    return <></>;
                  }
                })





                  ()}
                {(() => {
                  if (popupName == "Secondary Review") {
                    return (<>
                      <Col md="12" sm="12" xs="12" className="pb-0">

                        <label>
                          Shared Commentary
                        </label>
                        <Form.Group className="mb-3" controlId="formBasicCheckbox">
                          <Form.Control
                            as="textarea"
                            rows={6}
                            name="sharedCommentaryText"
                            value={inputValues.sharedCommentaryText}
                            onChange={handleFormChange}
                            
                          />
                        </Form.Group>
                      </Col>{
                        reviewDetail?.sharedCommentary?
                        <Col xs="12" sm="12" md="12">
                        Last saved by: <span className="LightText">{reviewDetail?.sharedCommentary?.commentedByUser+" "+moment(reviewDetail?.sharedCommentary?.commentedOn).local().format("MM/DD/YYYY hh:mm A")}</span>
                      </Col>
                      :<></>
                      }
                      

                    </>)
                  }
                })()}
              </Container>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="buttonCss"
              onClick={() => {
                updatePrimaryModalState();
                primaryPopupReadOnly(false);
                resetForm();
              }}
            >
              Cancel
            </button>
            <button
              className="buttonCss"
              onClick={(e) => {
                preventDefault(e);
                onSubmit();
              }}
              disabled={readOnly && popupName != "Secondary Review"}
            >
              Save
            </button>
          </Modal.Footer>
        </Modal>
        <RecommendationView
          recommendationDetail={viewRecommendationDetail}
          hideRecommendationPopup={hideRecommendationPopup}
        />
        <DeleteConfirmation
          deletePopup={deletePopup}
          cancelDelete={cancelDelete}
          confirmDelete={confirmDelete}
        />
      </>
    );
  } else {
    return <></>;
  }
}
